import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import PoweredByJibber from '/chat/src/components/PoweredByJibber';
import SystemModel from '/chat/src/redux/model/system/model';
import style from './style.scss';

import HeaderTitle from '/chat/src/components/Header/Title';
import HeaderAutomessage from '/chat/src/components/Header/AutoMessage'
import {CloseButton, FaqButton} from '/chat/src/components/Buttons';
import HeaderRightToolBelt from '/chat/src/components/Header/Toolbelt/RightSide'
import Customization from '/chat/src/redux/model/customization/model';
import TextDisplay from '/chat/src/components/TextDisplay'

class Header extends Component {
    constructor(props){
        super(props);
        this.state = {
            HeaderHeight: 0,
        }
        this._faqOnClick = this._faqOnClick.bind(this);
    }

    _faqOnClick(){
        this.props.dispatch(SystemModel.setRoute('Faq'));
    }

    render(){
        const { company, features, language, name, formsSetting } = this.props
        const hasFaq = features.get('hasFaq');
        const welcomeTo = language.get("WelcomeTo")
        let text = this.props.language.get('OfflineMessage')

        if(formsSetting){
            if(formsSetting['config']['is_overide_message'] && formsSetting['config']['message']){
                text = formsSetting['config']['message']
            } else if(formsSetting['message']){
                text = formsSetting['message']
            }
        }

        return(
            <div style={{backgroundColor: this.props.color}}>
                <div className={style.Header}>
                    <HeaderTitle title={welcomeTo} body={name}/>
                    <div style={{height: '10px'}}></div>
                    <TextDisplay text={text} />
                    <HeaderRightToolBelt>
                        {hasFaq &&<FaqButton color='white'/>}
                        <CloseButton/>
                    </HeaderRightToolBelt>
                </div>
            </div>
        )

    }
}


function mapStateToProps(state) {
    const color = Customization.getColor(state);
    const language = Customization.getLanguage(state);
    const name = Customization.getCompanyDisplayName(state);
    const offline = state.getIn(['features', 'features_payload', 'offline'], null)
    return {
        color: color,
        language: language,
        company: state.get('company'),
        features: state.get('features'),
        system: state.get('system'),
        name: name,
        formsSetting: Customization.getOfflineFormsSettings(state).toJS(),
    };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./routes/OfflineFormular/Header.js